import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { GET_PLC_SAFETY_EVENTS } from './actionTypes';
import { getPlcSafetyEventsSuccess, getPlcSafetyEventsError } from './actions';
import { getPlcSafetyAPI } from '../../../api/plcSafety';

const plcSafetyAPI = getPlcSafetyAPI();

function* getEvents({ payload: { user } }) {
  try {
    const response = yield call(plcSafetyAPI.getEvents, user.token);
    yield put(getPlcSafetyEventsSuccess(response));
  } catch (error) {
    yield put(getPlcSafetyEventsError(error));
  }
}

export function* watchGetPlcSafetyEvents() {
  yield takeEvery(GET_PLC_SAFETY_EVENTS, getEvents);
}

function* getPlcSafetyEventsSaga() {
  yield all([fork(watchGetPlcSafetyEvents)]);
}

export default getPlcSafetyEventsSaga;
